import styled from "styled-components"

import { getPercentage } from "utils/getPercentage"

import { ValueWithPercentage, WidgetNote, WidgetValueWrapper } from "./styled"

const LegendItemRoot = styled.div<{ $inline?: boolean }>`
  display: flex;
  flex-direction: ${({ $inline }) => ($inline ? "row" : "column")};
  align-items: center;
  justify-content: center;
  gap: ${({ $inline }) => ($inline ? "4px" : "0")};
  text-align: center;
`

interface HalfDoughnutLegendItemProps {
  label: string
  color: string
  value: number
  total?: number
  inline?: boolean
}

export const HalfDoughnutLegendItem = ({ label, color, value, total, inline = false }: HalfDoughnutLegendItemProps) => (
  <LegendItemRoot $inline={inline}>
    <WidgetNote $color={color}>{label}</WidgetNote>
    <WidgetValueWrapper $inline={inline}>
      {total !== undefined ? (
        <ValueWithPercentage>
          {value.toLocaleString()}
          <span className="percentage">{getPercentage(value, total)}</span>
        </ValueWithPercentage>
      ) : (
        value.toLocaleString()
      )}
    </WidgetValueWrapper>
  </LegendItemRoot>
)
